module.exports = __webpack_public_path__ + "static/media/error_app_img.124c8777.svg";